import cs from "classnames";
import React from "react";

import { createAsyncInput } from "src/common/components/AsyncInput";

import "./TextArea.css";

const noop = (): void => {};

interface TextAreaProps {
	disabled?: boolean;
	rows?: number;
	value?: string | undefined;
	onChangeValue?(value: string | undefined): unknown;
}

const SyncTextArea: React.FunctionComponent<TextAreaProps> = ({
	disabled,
	rows = 5,
	value,
	onChangeValue = noop
}) => {
	const onChange = React.useCallback(
		(event: React.ChangeEvent<HTMLTextAreaElement>) => {
			onChangeValue(event.target.value || undefined);
		},
		[onChangeValue]
	);
	return (
		<textarea
			className={cs("text-area", { "text-area--disabled": disabled })}
			disabled={disabled}
			rows={rows}
			value={value || ""}
			onChange={onChange}
		/>
	);
};

export const TextArea = createAsyncInput(SyncTextArea);
